<template>
  <div class="main">
    <div class="banner container">
      <div class="inner">
        <div class="location-logo">
          <img src="../../assets/img/ip_banner.png" alt="" />
        </div>
        <div class="location-info">
          <h2>综合定位服务</h2>
          <p>针对精细化地理位置需求场景，提供高精度的数据支持</p>
        </div>
      </div>
    </div>
    <div class="container resolution">
      <h3 class="title">
        国内IP高精度定位接口服务
        <router-link :to="{ path: '/ip/doc' }"
          ><img src="../../assets/img/doc_tip.png" alt=""
        /></router-link>
      </h3>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr class="header">
            <td class="th">产品套餐</td>
            <td>
              <div class="combo">
                <p class="name">IP高精度定位专业版</p>
                <p class="price"><span>￥</span>9200</p>
              </div>
            </td>
            <td>
              <div class="combo">
                <p class="name">IP高精度定位增强版</p>
                <p class="price"><span>￥</span>22600</p>
              </div>
            </td>
            <td class="tag-recommend">
              <div class="combo">
                <p class="name">IP高精度定位旗舰版</p>
                <p class="price"><span>￥</span>54600</p>
              </div>
            </td>
            <td>
              <div class="combo">
                <p class="name">IP高精度定位至尊版</p>
                <p class="price"><span>￥</span>90000</p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td1">接口有效期</td>
            <td class="td1">1年</td>
            <td class="td1">1年</td>
            <td class="td1">1年</td>
            <td class="td1">1年</td>
          </tr>
          <tr>
            <td>请求次数限制</td>
            <td class="td2">
              <span>1万次/日</span>
              <br />
              <span>1000次/时</span>
            </td>
            <td class="td2">
              <span>5万次/日</span>
              <br />
              <span>5000次/时</span>
            </td>
            <td class="td2">
              <span>10万次/日</span>
              <br />
              <span>10000次/时</span>
            </td>
            <td class="td2">
              <span>20万次/日</span>
              <br />
              <span>20000次/时</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-container">
        <a
          class="btn"
          target="_blank"
          href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
          >联系商务</a
        >
      </div>
    </div>
    <div class="container resolution">
      <h3 class="title">
        国内IP区域定位接口服务
        <router-link :to="{ path: '/ip/doc' }"
          ><img src="../../assets/img/doc_tip.png" alt=""
        /></router-link>
      </h3>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr class="header">
            <td class="th">产品套餐</td>
            <td>
              <div class="combo">
                <p class="name">区域定位体验版</p>
                <p class="price"><span>￥</span>0</p>
              </div>
            </td>
            <td>
              <div class="combo">
                <p class="name">区域定位专业版</p>
                <p class="price"><span>￥</span>6000</p>
              </div>
            </td>
            <td class="tag-recommend">
              <div class="combo">
                <p class="name">区域定位增强版</p>
                <p class="price"><span>￥</span>17600</p>
              </div>
            </td>
            <td>
              <div class="combo">
                <p class="name">区域定位旗舰版</p>
                <p class="price"><span>￥</span>32000</p>
              </div>
            </td>
          </tr>
          <tr>
            <td class="td1">接口有效期</td>
            <td class="td1">7天</td>
            <td class="td1">1年</td>
            <td class="td1">1年</td>
            <td class="td1">1年</td>
          </tr>
          <tr>
            <td>请求次数限制</td>
            <td class="td2">
              <span>1万次/日</span>
              <br />
              <span>1000次/时</span>
            </td>
            <td class="td2">
              <span>1万次/日</span>
              <br />
              <span>1000次/时</span>
            </td>
            <td class="td2">
              <span>5万次/日</span>
              <br />
              <span>5000次/时</span>
            </td>
            <td class="td2">
              <span>10万次/日</span>
              <br />
              <span>10000次/时</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-container">
        <a
          class="btn"
          target="_blank"
          href="https://wpa.qq.com/msgrd?v=3&uin=258620589&site=qq&menu=yes"
          >联系商务</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IpHome",
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

/* banner样式 */

.banner {
  margin-top: 30px;
}

.banner .inner {
  text-align: center;
}

.banner .inner .location-logo {
}

.banner .inner .location-logo img {
  width: 280px;
  height: 200px;
}

.banner .inner .location-info {
  box-sizing: border-box;
}

.banner .inner .location-info h2 {
  font-size: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 56px;
  margin: 0px 0 10px;
}

.banner .inner .location-info p {
  font-size: 16px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
}

/* 解决方案 */

.resolution {
  margin-top: 40px;
  margin-bottom: 40px;
  background: linear-gradient(
    180deg,
    rgba(183, 183, 183, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  );
  box-shadow: 0px 14px 10px 0px rgba(0, 0, 0, 0.3);
  border-radius: 15px;
  border: 2px solid;
  padding: 0 24px 40px;
  filter: blur(0.5px);
}

.resolution .tag-recommend {
  position: relative;
  overflow: hidden;
}

.resolution .tag-recommend::after {
  content: "推荐";
  position: absolute;
  background-color: red;
  color: #fff;
  font-size: 12px;
  right: -24px;
  top: 10px;
  height: 20px;
  width: 100px;
  line-height: 20px;
  transform: rotate(40deg);
}

.resolution .tag-new {
  position: relative;
  overflow: hidden;
}

.resolution .tag-new::after {
  content: "最新";
  position: absolute;
  background-color: red;
  color: #fff;
  font-size: 12px;
  right: -24px;
  top: 10px;
  height: 20px;
  width: 100px;
  line-height: 20px;
  transform: rotate(40deg);
}

.resolution > div:last-child {
  margin-top: 50px;
}

.resolution table tr:last-child {
  height: 80px;
}

.resolution .title {
  text-align: center;
  font-weight: 400;
  font-size: 36px;
  font-family: GlowSansSC-Normal-Heavy, GlowSansSC-Normal;
  font-weight: 800;
  color: rgba(255, 148, 95, 0.5);
  line-height: 52px;
}

.resolution .title a {
  margin-left: 20px;
  text-decoration: none;
  font-size: 14px;
}

.resolution table {
  border: 0;
}

.resolution table tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.resolution table tr:nth-child(even) {
  background-color: #fff;
}

.resolution table tr.header {
  background-color: #fd975e;
  color: #fff;
}

.resolution .th {
  font-size: 24px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 33px;
}

.combo .name {
  margin: 0 0 16px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 25px;
}

.combo .price {
  margin: 0;
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 50px;
}

.combo .price span {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 25px;
}

.resolution table td {
  width: 20%;
  text-align: center;
  padding: 24px 0;
}

.resolution table td.td1 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}
.resolution table td.td2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.resolution table td span {
  display: inline-block;
  padding: 5px 0;
}

.resolution .btn-container {
  text-align: center;
}

.resolution .btn-container a {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ff9459;
  line-height: 33px;
  text-decoration: none;
  padding: 13px 41px;
  border: 1px solid #ff9459;
}
</style>